(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silviate-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('silviate-viewer')){customElements.define('silviate-viewer',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('button').addEventListener('click',()=>this.load())}load(){const button=this.querySelector('button');const stage=this.querySelector('.sv-model-stage');const status=this.querySelector('[role="status"]');button.disabled=true;status.textContent='';const fail=()=>{stage.hidden=true;stage.replaceChildren();this.querySelector('.sv-poster').hidden=false;button.disabled=false;status.textContent=this.dataset.error};if(!window.Shopify?.loadFeatures){fail();return}Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:errors=>{if(errors){fail();return}stage.replaceChildren(this.querySelector('template').content.cloneNode(true));stage.hidden=false;const model=stage.querySelector('model-viewer');model.addEventListener('error',fail,{once:true});model.addEventListener('load',()=>{this.querySelector('.sv-poster').hidden=true;model.setAttribute('tabindex','0');model.focus();},{once:true});this.querySelector('.sv-poster').hidden=true;}}])}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-comparison"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sv-example-compare'))customElements.define('sv-example-compare',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();const o={signal:this.abort.signal};this.stage=this.querySelector('.sv-example-stage');this.range=this.querySelector('input');this.button=this.querySelector('[data-play]');this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.playing=this.dataset.auto==='true'&&!this.motion.matches;this.visible=false;this.start=0;this.render=()=>this.stage.style.setProperty('--split',this.range.value+'%');this.label=()=>{this.button.textContent=this.playing?this.button.dataset.pause:this.button.dataset.resume;this.button.setAttribute('aria-pressed',String(this.playing))};this.stop=()=>{this.playing=false;cancelAnimationFrame(this.frame);this.label()};this.range.addEventListener('input',()=>{this.stop();this.render()},o);this.range.addEventListener('keydown',this.stop,o);const move=e=>{const r=this.stage.getBoundingClientRect();this.range.value=String(Math.round(Math.max(0,Math.min(100,(e.clientX-r.left)/r.width*100))));this.render()};this.stage.addEventListener('pointerdown',e=>{if(e.button!==0)return;this.stop();this.dragging=true;this.stage.setPointerCapture(e.pointerId);this.range.focus({preventScroll:true});move(e);e.preventDefault()},o);this.stage.addEventListener('pointermove',e=>{if(this.dragging)move(e)},o);for(const event of ['pointerup','pointercancel','lostpointercapture'])this.stage.addEventListener(event,()=>this.dragging=false,o);this.button.addEventListener('click',()=>{this.playing=!this.playing;this.start=0;this.label();this.run()},o);this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.run()},{threshold:.15});this.observer.observe(this);document.addEventListener('visibilitychange',()=>this.run(),o);this.motion.addEventListener('change',()=>{if(this.motion.matches)this.stop()},o);this.label()}
 run(){cancelAnimationFrame(this.frame);if(!this.playing||!this.visible||document.hidden)return;this.start=0;const tick=t=>{if(!this.start)this.start=t;this.range.value=String(Math.round(50+30*Math.sin((t-this.start)/2400)));this.render();this.frame=requestAnimationFrame(tick)};this.frame=requestAnimationFrame(tick)}
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-model-premium"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sv-model-premium'))customElements.define('sv-model-premium',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.finish='gold';this.stage=this.querySelector('.sv-model-stage');this.poster=this.querySelector('.sv-model-poster');this.status=this.querySelector('[role=status]');this.button=this.querySelector('[data-load]');this.button.addEventListener('click',()=>this.load());this.loadObserver=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){this.loadObserver.disconnect();this.load()}},{rootMargin:'100px'});this.loadObserver.observe(this);this.querySelectorAll('[data-metal]').forEach(button=>button.addEventListener('click',()=>{this.finish=button.dataset.metal;this.querySelectorAll('[data-metal]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));this.poster.querySelector('[data-finish]').dataset.finish=this.finish;this.material()}));this.querySelector('[data-reset]').addEventListener('click',()=>{if(this.viewer){this.viewer.cameraOrbit='-12deg 82deg 125%';this.viewer.fieldOfView='30deg'}})}
 material(){const material=this.viewer?.model?.materials?.find(item=>item.name==='Polished metal');if(!material)return;const colors={silver:[.82,.83,.85,1],gold:[1,.71,.29,1],rose:[.95,.56,.42,1]};material.pbrMetallicRoughness.setBaseColorFactor(colors[this.finish]);material.pbrMetallicRoughness.setMetallicFactor(1);material.pbrMetallicRoughness.setRoughnessFactor(.095)}
 load(){if(this.button.disabled||this.viewer)return;this.button.disabled=true;this.status.textContent=this.dataset.loading;const fail=()=>{clearTimeout(this.timer);this.stage.hidden=true;this.stage.replaceChildren();this.poster.hidden=false;this.button.disabled=false;this.status.textContent=this.dataset.error;this.viewer=null};if(!window.Shopify?.loadFeatures){fail();return}this.timer=setTimeout(fail,30000);Shopify.loadFeatures([{name:'model-viewer',version:'1.12',onLoad:errors=>{if(errors){fail();return}this.stage.replaceChildren(this.querySelector('template').content.cloneNode(true));this.viewer=this.stage.querySelector('model-viewer');this.viewer.addEventListener('error',fail,{once:true});this.viewer.addEventListener('load',()=>{clearTimeout(this.timer);this.material();this.poster.hidden=true;this.status.textContent='';this.setupScroll()},{once:true});this.stage.hidden=false;this.poster.hidden=true}}])}
 setupScroll(){if(this.scrollHandler)return;const story=this.closest('.sv-material-story'),motion=matchMedia('(prefers-reduced-motion: reduce)');this.scrollHandler=()=>{if(motion.matches||!this.viewer||this.manual)return;const rect=story.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight)return;const progress=Math.max(0,Math.min(1,-rect.top/Math.max(1,rect.height-innerHeight)));this.viewer.cameraOrbit=`${-24+progress*72}deg ${78+Math.sin(progress*Math.PI)*10}deg 125%`};this.viewer.addEventListener('pointerdown',()=>this.manual=true);this.viewer.addEventListener('keydown',()=>this.manual=true);this.querySelector('[data-reset]').addEventListener('click',()=>{this.manual=false;this.scrollHandler()});window.addEventListener('scroll',this.scrollHandler,{passive:true});this.scrollHandler()}
 disconnectedCallback(){this.loadObserver?.disconnect();clearTimeout(this.timer);window.removeEventListener('scroll',this.scrollHandler)}
});

  } catch(e) { console.error(e); }
})();
})();
